import { render, staticRenderFns } from "./prize_meta_daily.vue?vue&type=template&id=ec26eb24&"
import script from "./prize_meta_daily.vue?vue&type=script&lang=js&"
export * from "./prize_meta_daily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports